import React from 'react';
import { Dialog } from 'primereact/dialog';

import logo from '../assets/logo_patos.png';

export const DialogRotas = ({ visible, setVisible, rota }) => {
    const listaRotas = rota.map (item => {
        return (
                <tr key={item.id}>
                    <td width="230px" align='center'><span>{item.id !== undefined ? item.id : item[0].id}</span></td>
                    <td width="230px" align='center'> <span>{item.id !== undefined ? item.rota : item[0].rota}</span></td>
                </tr>
        )
    })

    return (
        <Dialog
            visible={visible}
            onHide={() => setVisible(false)}
            className='p-scrollpanel-bar-y'
            breakpoints={{ '960px': '75vw', '640px': '100vw' }}
            style={{ width: '50vw', heigth: '5vw' }}
        >
            {/* {escola.length > 0 ? */}
                <div>
                    <div className="p-d-flex p-jc-center header-img">
                    <img style={{width:150, height:150}}
                            id="logo"
                            alt="Logo"
                            src={logo}
                        />
                    </div>
                    <div className="p-d-flex p-ai-center p-flex-column header">
                        <h2>Preços</h2>

                    </div>
                    <table width="100%" border="1" style={{'border-collapse': 'collapse'}} cellpadding="15px" cellspacing="0">
                        <thead>
                            <tr>
                                <th width="100px" ><h2><i>Código</i></h2></th>
                                <th width="100px" ><h2><i>Rota</i></h2></th>
                            </tr>
                        </thead>

                        <tbody>
                            {listaRotas}
                        </tbody>


                    </table>

                </div>
        </Dialog>
    );
}
